import { createSelector } from '@ngrx/store';
import { selectCurrentPageState } from '../core.state';
import { CurrentPageState } from './current-page.models';

export const selectCurrentPage = createSelector(
  selectCurrentPageState,
  (state: CurrentPageState) => state.currentPage
);

export const selectInFlightDialogs = createSelector(
  selectCurrentPageState,
  (state: CurrentPageState) => state.inFlightDialogs
);
